<template>
  <div id="ylNewsList">
    <ylNewsListMobile
      v-if="isMobileScreen"
      v-bind="$attrs"
       />
    <ylNewsListPC
      v-else
      v-bind="$attrs"
       />
  </div>
</template>
<script>
export default {
  name: "ylNewsList",
  components: {
    ylNewsListMobile: () => import("./components/mobile.vue"),
    ylNewsListPC: () => import("./components/pc.vue"),
  },
  data() {
    return {};
  },
  computed: {
    screenWidth() {
      return this.$store.getters.screenWidth;
    },
    screenHeight() {
      return this.$store.getters.screenHeight;
    },
    isMobileScreen() {
      return this.$store.getters.isMobileScreen;
    },
  },
  created() {},
  methods: {},
};
</script>